import { RouteRecordRaw } from 'vue-router';

export default {
  path: '/announcement',
  name: 'announcement',
  redirect: '/announcement/index',
  component: () => import('@/layout/index.vue'),
  meta: {
    title: 'menus.announcement',
    icon: 'el-icon-Guide',
    sort: 5
  },
  children: [
    {
      path: '/announcement/index',
      name: 'announcement_index',
      component: () => import('@/views/announcement/index.vue'),
      meta: {
        title: 'menus.announcement_index',
        icon: 'el-icon-Service'
      }
    },
    {
      path: '/announcement/detail',
      name: 'announcement_detail',
      component: () => import('@/views/announcement/detail.vue'),
      meta: {
        title: 'menus.announcementDetail',
        isMenu: false
      }
    }
  ]
} as RouteRecordRaw;
